import styled from 'styled-components';
import { Button } from '@app/src/common/Button';
import { SIZE } from '@app/src/ui';

interface ButtonProps {
  fixed?: boolean;
}

export const ButtonActionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  ${(props: ButtonProps) => props.fixed &&
    `
      position: fixed;
      z-index: 1000;
      width: 100%;
      bottom: 0;
      padding: 8px 15px;
      background: #fff;
      margin-left: -15px;
    `
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    margin-bottom: 15%;
  }
`;

export const ButtonPrevWrapper = styled(Button)`
  height: 55px;
  font-size: 14px;
  font-weight: 600;
  svg {
    flex: 0 0 auto;
    margin-right: 6px;
  }
  span {
    text-align: left;
  }
`;

export const ButtonNextWrapper = styled(Button)`
  height: 55px;
  font-size: 14px;
  font-weight: 600;
  svg {
    transform: rotate(180deg);
    margin-left: 6px;
  }
`;

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`;
